import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private tryForContentObservable$ = new BehaviorSubject('GENERAL.ContactUs');

  public tryForContent = this.tryForContentObservable$.asObservable();

  setContent(content: string) {
    this.tryForContentObservable$.next(content);
  }
}
